import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY_MAP } from 'src/constants';
import { getAllSimCardDetailsPromise } from 'src/utils/api/get-sim-card-details';

export const useGetAllSimCardDetails = (status?: string) => {
  const { data, isLoading, error, isRefetching } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetAllSimCardDetails, status],
    queryFn: () => getAllSimCardDetailsPromise(status),
  });

  return {
    data,
    isLoading,
    error,
    isRefetching,
  };
};
